import React, { useState } from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { ModalPortal } from '../../components';
import { ReviewForm } from '../../forms';

import css from './ReviewModal.css';

const ReviewModal = ({
    className,
    rootClassName,
    id,
    isOpen,
    onClose: onCloseModal,
    onRespondOnCustomerInquiry,
    revieweeName,
    reviewSent,
    sendReviewInProgress,
    sendReviewError,
    otherPartyUserType,
    otherParty,
    currentUser,
    currentListing,
    inquiryError,
}) => {
    const [refreshModalScrollPosKey, setRefreshModalScrollPosKey] = useState();
    const classes = classNames(rootClassName || css.root, className);

    const reviewee = <span className={css.reviewee}>{revieweeName}</span>;

    return (
        <ModalPortal
            id={id}
            containerClassName={classes}
            contentClassName={css.modalContent}
            isOpen={isOpen}
            onClose={onCloseModal}
            unsetKey={refreshModalScrollPosKey}
            containerClassNameJoined
            isSticky
        >
            <h3 className={css.modalTitle}>
                <FormattedMessage id="ReviewModal.title" values={{ revieweeName: reviewee }} />
            </h3>
            <p className={css.modalMessage}>
                <FormattedMessage id="ReviewModal.description" />
            </p>
            {inquiryError && (
                <p className={css.error}>
                    {(typeof inquiryError === 'string' ? inquiryError : inquiryError.message) ||
                        'Something went wrong. Try later.'}
                </p>
            )}
            <ReviewForm
                onSubmit={onRespondOnCustomerInquiry}
                reviewSent={reviewSent}
                sendReviewInProgress={sendReviewInProgress}
                sendReviewError={sendReviewError}
                otherPartyUserType={otherPartyUserType}
                otherParty={otherParty}
                currentUser={currentUser}
                currentListing={currentListing}
                setRefreshModalScrollPosKey={setRefreshModalScrollPosKey}
            />
        </ModalPortal>
    );
};

export default ReviewModal;
